<template>
    <div class="d-sm-flex align-items-center justify-content-between mb-2">
        <div>
            <ol class="breadcrumb fs-sm mb-1">
                <li class="breadcrumb-item">
                    <router-link to="/dashboard">Dashboard</router-link>
                </li>
                <li class="breadcrumb-item active" aria-current="page">Inspect Stages</li>
            </ol>
            <h4 class="main-title mb-0">Inspect Stages</h4>
        </div>
        <div>
        <router-link to="/inspectstages" class="btn btn-danger me-2"><i class="ri-close-line fs-18 lh-1"></i> Back</router-link>
        <button class="btn btn-primary " @click.prevent="submitForm()">
                        <span v-if="status"><i class="ri-save-line fs-18 lh-1"></i> Submit</span>
                        <span v-else><i class="ri-save-line fs-18 lh-1"></i> Update</span>
                    </button>
                </div>
        
    </div>
    <div class="row g-3">
        <div class="col-sm-12">
            <div class="card card-one">
                <div class="card-header">
                    <h6 class="card-title">New Inspect Stage</h6>
                    <nav class="nav ms-auto"></nav>
                </div>
                <div class="card-body">
                    <div class="row g-2 mb-3">
                        <div class="col-md-4">
                            <label class="form-label">Inspect Stage Name</label><span class="text-danger"> *</span>
                            <input type="text" placeholder="Inspect Stage Name" class="form-control" :class="{ 'is-invalid': errors.inspect_stage_name }" v-model="inspect_stage.inspect_stage_name" ref="inspect_stage_name" />
                            <span v-if="errors.inspect_stage_name"><small class="text-danger">{{ errors.inspect_stage_name[0] }}</small></span>
                        </div>
                        <div class="col-md-4">
                            <label class="form-label">Inspect Stage Type</label><span class="text-danger"> *</span>
                            <select class="form-control" :class="{ 'is-invalid': errors.inspect_stage_type }" v-model="inspect_stage.inspect_stage_type">
                                <option value="">Select Inspect Stage type</option>
                                <option value="inward">Inward</option>
                                <!-- <option value="outward">Outward</option> -->
                            </select>
                            <span v-if="errors.inspect_stage_type"><small class="text-danger">{{ errors.inspect_stage_type[0] }}</small></span>
                        </div>
                        <div class="col-md-4">
                            <label class="form-label">Order</label><span class="text-danger"> *</span>
                            <input type="text" placeholder="Order" class="form-control" :class="{ 'is-invalid': errors.order }" v-model="inspect_stage.order" />
                            <span v-if="errors.order"><small class="text-danger">{{ errors.order[0] }}</small></span>
                        </div>
                    </div>

                    <div class="row g-2">
                        <div class="col-md-12">
                            <div class="table-responsive table-responsive-sm">
                                <table class="table table-sm text-wrap table-bordered mb-0">
                                    <thead>
                                        <tr>
                                            <th>Inspect Check Name<span class="text-danger"> *</span></th>
                                            <th>Field Type</th>
                                            <th>Default Value<span class="text-danger"> *</span></th>
                                            <th>Min</th>
                                            <th>Max</th>
                                            <th>Field Values</th>
                                            <th>Order<span class="text-danger"> *</span></th>
                                            <th v-if="inspect_check.field_type == 'radio'">Is Image Required</th>
                                            <th class="text-center">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <input text="text" class="form-control" placeholder="Inspect Check Name" :class="{ 'is-invalid': errors.inspect_check_name }" v-model="inspect_check.inspect_check_name" />
                                                <span v-if="errors.inspect_check_name" class="invalid-feedback">{{ errors.inspect_check_name[0] }}</span>
                                            </td>
                                            <td>
                                                <select class="form-control" :class="{ 'is-invalid': errors.field_type}" v-model="inspect_check.field_type">
                                                    <option value="text">Text</option>
                                                    <option value="number">Number</option>
                                                    <option value="radio">Radio</option>
                                                    <!----<option value="dropdown">Dropdown</option>--->
                                                    <option value="select">Select</option>
                                                </select>
                                                <!-- <input text="text" class="form-control" placeholder="Field Type" :class="{ 'is-invalid': errors.field_type }" v-model="check.field_type" /> -->
                                                <span v-if="errors.field_type" class="invalid-feedback">{{ errors.field_type[0] }}</span>
                                            </td>

                                            <td>
                                                <input type="text" placeholder="Default Value" class="form-control" :class="{ 'is-invalid': errors.default_value }" v-model="inspect_check.default_value" />
                                                <span v-if="errors.default_value" class="invalid-feedback">{{ errors.default_value[0] }}</span>
                                            </td>
                                            <td>
                                                <input type="text" placeholder="Min" class="form-control" :class="{ 'is-invalid': errors.min }" v-model="inspect_check.min" />
                                                <span v-if="errors.min" class="invalid-feedback">{{ errors.min[0] }}</span>
                                            </td>
                                            <td>
                                                <input type="text" placeholder="Max" class="form-control" :class="{ 'is-invalid': errors.max }" v-model="inspect_check.max" />
                                                <span v-if="errors.max" class="invalid-feedback">{{ errors.max[0] }}</span>
                                            </td>
                                            <td>
                                                <input v-if="inspect_check.field_type == 'text' || inspect_check.field_type == 'number' || inspect_check.field_type == 'radio'" type="text" placeholder="Field Values" class="form-control" :class="{ 'is-invalid': errors.field_values }" v-model="inspect_check.field_values" />
                                                <input v-else-if="inspect_check.field_type == 'dropdown'" type="text" placeholder="Field Values" class="form-control" :class="{ 'is-invalid': errors.dropdown }" v-model="inspect_check.field_values" />
                                                <input v-else-if="inspect_check.field_type == 'select'" type="text" placeholder="Field Values" class="form-control" :class="{ 'is-invalid': errors.select }" v-model="inspect_check.field_values" />
                                                <span v-if="errors.field_values" class="invalid-feedback">{{ errors.field_values[0] }}</span>
                                                <span v-if="errors.dropdown" class="invalid-feedback">{{ errors.dropdown[0] }}</span>
                                                <span v-if="errors.select" class="invalid-feedback">{{ errors.select[0] }}</span>
                                            </td>
                                            <!-- <td>
                                                <input type="text" placeholder="Field Values" class="form-control" :class="{ 'is-invalid': errors.field_values }" v-model="check.field_values" />
                                                
                                                <span v-if="errors.field_values" class="invalid-feedback">{{ errors.field_values[0] }}</span>
                                            </td> -->
                                            <td>
                                                <input type="text" placeholder="Order" class="form-control" :class="{ 'is-invalid': errors.inspect_check_order }" v-model="inspect_check.order" />
                                                <span v-if="errors.inspect_check_order" class="invalid-feedback">{{ errors.inspect_check_order[0] }}</span>
                                            </td>
                                            <td v-if="inspect_check.field_type == 'radio'"style="width:130px; text-align: center;"><div class="form-check form-check-inline mt-1">
                                                <input class="form-check-input " type="checkbox" :checked="inspect_check.is_image_required" v-model="inspect_check.is_image_required" id="flexCheckDefault">
                                                <label class="form-check-label" for="flexCheckDefault"></label>
                                            </div>
        
                                            <!-----<div class="form-check form-check-inline mt-1">
                                                <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                                                <label class="form-check-label" for="flexCheckDefault">
                                                    No
                                                </label>
                                            </div>--->
                                              <!-- <  <input class="form-control" type="checkbox" :checked="check.is_image_required" :value="check.is_image_required" :class="{ 'is-invalid': errors.check_is_image_required }" />
                                                <span v-if="errors.check_is_image_required" class="invalid-feedback">{{ errors.check_is_image_required[0] }}</span> -->
                                            </td>
                                            <td class="text-center">
                                                <button v-if="formStatus" @click="addRow()" class="btn btn-sm btn-primary"><i class="ri-add-line"></i></button>
                                                <button v-else @click="updateRow()" class="btn btn-sm btn-primary"><i class="ri-save-line"></i></button>
                                            </td>
                                        </tr>
                                        <tr v-for="(inspect_check, key) in inspect_stage.inspect_checks" :key="key">
                                            <td>{{ inspect_check.inspect_check_name }}</td>
                                            <td>{{ inspect_check.field_type }}</td>
                                            <td>{{ inspect_check.default_value }}</td>
                                            <td>{{ inspect_check.min }}</td>
                                            <td>{{ inspect_check.max}}</td>
                                            <td>{{ inspect_check.field_values }}</td>
                                            <td>{{ inspect_check.order}}</td>
                                             <td>{{ inspect_check.is_image_required }}</td>
                                            <td class="text-center d-flex">
                                                <button class="btn btn-outline-success me-2" data-toggle="tooltip" data-placement="bottom" title="Edit" @click="editRow(inspect_check,key)">
                                                    <i class="ri-pencil-line fs-18 lh-1"></i>
                                                </button>
                                                <button class="btn btn-outline-danger" type="button" @click="deleteRow(inspect_check,key)">
                                                    <i class="ri-delete-bin-line fs-18 lh-1"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="card-footer text-end">
                    <button class="btn btn-primary " @click.prevent="submitForm()">
                        <span v-if="status"><i class="ri-save-line fs-18 lh-1"></i> Submit</span>
                        <span v-else><i class="ri-save-line fs-18 lh-1"></i> Update</span>
                    </button>
                </div> -->
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        components: {},
        data() {
            return {
                inspect_stage: {
                    inspect_stage_id: "",
                    inspect_stage_name: "",
                    inspect_stage_type: "",
                    order: "",
                    // stage_order:"",
                    inspect_checks: [],
                    deleted_inspect_checks: [],
                },
                inspect_check: {
                    inspect_check_id: "",
                    inspect_check_name: "",
                    field_type: "text",
                    default_value: "",
                    min: "",
                    max: "",
                    field_values: "",
                    order: "",
                    order: "",
                    is_image_required:false,
                },
                status: true,
                formStatus: true,
                inspect_stages: [],
                errors: [],
            };
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                // vm.getRoles();
                if (to.name == "InspectStages.Create") {
                    vm.$refs.inspect_stage_name.focus();
                } else {
                    vm.status = false;
                    let uri = { uri: "getInspectStage", data: { inspect_stage_id: to.params.inspect_stage_id } };
                    vm.$store
                        .dispatch("post", uri)
                        .then(function (response) {
                            vm.inspect_stage = response.data.data;
                        })
                        .catch(function (error) {
                            vm.errors = error.response.data.errors;
                            vm.$store.dispatch("error", error.response.data.message);
                        });
                }
            });
        },

        methods: {
            submitForm() {
                let vm = this;
                if (vm.status) {
                    vm.addInspectStage();
                } else {
                    vm.updateInspectStage();
                }
            },
            addRow() {
                let vm = this;
                
                if(vm.isEmpty()){
                    vm.inspect_stage.inspect_checks.push({
                        inspect_check_name: vm.inspect_check.inspect_check_name,
                        field_type: vm.inspect_check.field_type,
                        default_value: vm.inspect_check.default_value,
                        min: vm.inspect_check.min,
                        max: vm.inspect_check.max,
                        field_values: vm.inspect_check.field_values,
                        order: vm.inspect_check.order,
                        is_image_required: vm.inspect_check.is_image_required,
                    });
                    vm.discardForm();
                }
            },
            isEmpty() {
                let vm = this
                if(!vm.inspect_check.inspect_check_name){
                    vm.errors.inspect_check_name = ["Inspect Check name field cannot be empty"]
                }else{
                    delete vm.errors.Inspect_check_name
                }
                if(!vm.inspect_check.default_value){
                    vm.errors.default_value = ["Default value field cannot be empty"]
                }else{
                    delete vm.errors.default_value
                }
                if(!vm.inspect_check.order){
                    vm.errors.inspect_check_order = ["Inspect Check order field cannot be empty"]
                }else{
                    var number_regex=/^\d+$/
                    var validate_order = number_regex.test(vm.inspect_check.order)
                    if(!validate_order){
                        vm.errors.inspect_check_order = ["The order field must be integer"]
                    }else{
                        delete vm.errors.inspect_check_order
                    }
                }
                if(!vm.inspect_check.default_value){
                    vm.errors.default_value = ["default value field cannot be empty"]
                }else{
                    delete vm.errors.default_value
                }
                if (vm.inspect_check.field_type =='number' && !vm.inspect_check.min) {
                    vm.errors.min = ["Min field cannot be empty"];
                 } else if(vm.inspect_check.field_type != 'number' && vm.inspect_check.min) {
                    var number_regex = /^\d+(\.\d+)?$/;
                    var validate_min = number_regex.test(vm.inspect_check.min);
                   // console.log(validate_min);
                    if (!validate_min) {
                        vm.errors.min = ["The min field must be a number"];
                    } else {
                        delete vm.errors.min;
                    }
                }
                if(vm.inspect_check.field_type == 'number' && !vm.inspect_check.max){
                    vm.errors.max = ["Max field cannot be empty"]
                }else if(vm.inspect_check.field_type != 'number' && vm.inspect_check.max) {
                    var number_regex = /^\d+(\.\d+)?$/;
                    var validate_max = number_regex.test(vm.inspect_check.max);
                   // console.log(validate_min);
                    if (!validate_max) {
                        vm.errors.max = ["The max field must be a number"];
                     }else{
                    delete vm.errors.max
                    }
                }   
                if(!vm.inspect_check.default_value){
                    vm.errors.default_value = ["default value field cannot be empty"]
                }else{
                    delete vm.errors.default_value
                }
                if((vm.inspect_check.field_type == 'radio' || vm.inspect_check.field_type == 'select') && !vm.inspect_check.field_values){
                    vm.errors.field_values = ["Field values field cannot be empty"]
                }else{
                    delete vm.errors.field_values
                }
                if(!vm.inspect_check.default_value){
                    vm.errors.default_value = [" default value field cannot be empty"]
                }else{
                    delete vm.errors.default_value
                }
                for(var prop in this.errors) {
                    if(this.errors.hasOwnProperty(prop))
                        return false;
                }
                return true;
            },
            validateRow(){

            },
            editRow(inspect_check, key) {
                let vm = this;
                vm.inspect_check = inspect_check;
                // console.log("check"vm.check
                vm.inspect_check.order = vm.inspect_check.order;
                vm.formStatus = false;
                vm.inspect_check.key = key;
                vm.errors = [];
            },
            
            updateRow() {
                let vm = this;
                vm.inspect_check.order = vm.inspect_check.order;
                if(vm.isEmpty()){
                    vm.inspect_stage.inspect_checks.push({
                        inspect_check_id: vm.inspect_check.check_id,
                        inspect_check_name: vm.inspect_check.inspect_check_name,
                        field_type: vm.inspect_check.field_type,
                        default_value: vm.inspect_check.default_value,
                        min: vm.inspect_check.min,
                        max: vm.inspect_check.max,
                        field_values: vm.inspect_check.field_values,
                        order: vm.inspect_check.order,
                        is_image_required: vm.inspect_check.is_image_required,
                    });
                    vm.inspect_stage.inspect_checks.splice(vm.inspect_check.key, 1);
                    vm.discardForm();
                }
              
                
            },
            deleteRow(inspect_check, key) {
                let vm = this;
                vm.inspect_stage.deleted_inspect_checks.push(inspect_check.inspect_check_id), vm.inspect_stage.inspect_checks.splice(key, 1);
                vm.discardForm();
            },
            discardForm() {
                console.log("&&&&&&")
                let vm = this;
                vm.inspect_check.inspect_check_name = "";
                vm.inspect_check.field_type = "text";
                vm.inspect_check.default_value = "";
                vm.inspect_check.min = "";
                vm.inspect_check.max = "";
                vm.inspect_check.field_values = "";
                vm.inspect_check.order = "";
                vm.inspect_check.is_image_required = false;
                vm.formStatus = true;
                vm.errors = [];
            },
            addInspectStage() {
                let vm = this;
                // vm.stage.order=vm.stage.stage_order;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "addInspectStage", data: vm.inspect_stage })
                    .then(function () {
                        loader.hide();
                        vm.$store.dispatch("success", "Inspect Stage is successfully created");
                        vm.$router.push("/inspectstages");
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            updateInspectStage() {
                let vm = this;
                // vm.stage.order=vm.stage.stage_order;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "updateInspectStage", data: vm.inspect_stage })
                    .then(function () {
                        loader.hide();
                        vm.$store.dispatch("success", "Inspect Stage is successfully updated");
                        vm.$router.push("/inspectstages");
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
        },
    };
</script>
